import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const AdminPartsChats = lazy(() => import("@/pages/admin/AdminPartsChats"));

function AdminPartsChatsRoute() {
  return (
    <Suspense fallback={<div className="min-h-screen bg-background" />}>
      <AdminPartsChats />
    </Suspense>
  );
}

export const Route = createFileRoute("/_adminLayout/admin/parts/chats")({
  component: AdminPartsChatsRoute,
});
